module.exports = __webpack_public_path__ + "static/media/pin.c161bcba.svg";